export default __webpack_public_path__ + "static/media/ADD4.bf977218.jpg";